import React from 'react'
import "./Tokenomics.css"
import tkn from "../Assets/tokenomics.png"
import l_roc from "../Assets/left_roc.png"
import r_roc from "../Assets/r_roc.png"
export default function Tokenomics() {
    return (
        <section className='main_tokenomics overflow-hidden position-relative' id='Tokenomics'>
            <div className="container">
            <div className='data-aos="fade-up"'>

          
                <h1 className='section_head text-center gor_font '>Tokenomics</h1>
          
                </div>
                <div className="row z-2 position-relative align-items-center justify-content-between mt-4">
                    <div className="col-md-7 col-lg-5 order-1 mt-3 mt-md-0 order-md-0" data-aos="fade-right">
                        <div className="tkn_box">


                         




                            <div className='content d-flex justify-content-between mx-3'>
                            <h1 className='section_head text-center gor_font '>$RBT.network</h1>
        
</div>
<div className='content_inner d-flex mt-3 align-items-center justify-content-between'>
    <div className='row w-100'>
        <div className='col-6 px-1 px-md-2'>
            <p className='tkn_card_head mb-0 d-flex align-items-center gap-2 nor_font fw-semibold' style={{ color: "#081B2CE5", fontSize: "16px" }}>
                <div className='grean_b'></div> Total Supply:
                
            </p>
        </div>
        <div className='col-6 px-1 px-md-2'>
            <p className='tkn_card_head text-start mb-0 nor_font fw-semibold' style={{ color: "#081B2CE5", fontSize: "16px" }}>100 billion</p>
        </div>
       
    </div>
</div>
<div className='content_inner d-flex mt-3 align-items-center justify-content-between'>
    <div className='row align-items-center w-100'>
        <div className='col-6 px-1 px-md-2'>
            <p className='tkn_card_head mb-0 d-flex align-items-center gap-2 nor_font fw-semibold' style={{ color: "#081B2CE5", fontSize: "16px" }}>
                <div className='grean_b'></div> Buy Fees:

            </p>
        </div>
        <div className='col-6 '>
            <p className='tkn_card_head mb-0 nor_font fw-semibold' style={{ color: "#081B2CE5", fontSize: "14px" }}>4% (3% rewards to holders, 1% marketing)
            </p>
        </div>
      
    </div>
</div>
<div className='content_inner d-flex mt-3 align-items-center justify-content-between'>
    <div className='row align-items-center w-100'>
        <div className='col-6  px-1 px-md-2'>
            <p className='tkn_card_head  mb-0 d-flex align-items-center gap-2 nor_font fw-semibold' style={{ color: "#081B2CE5", fontSize: "16px" }}>
            <div className='grean_b'></div>   Sell Fees:
            </p>
        </div>
        <div className='col-6  px-1 px-md-2'>
            <p className='tkn_card_head torun mb-0 nor_font fw-semibold' style={{ color: "#081B2CE5", fontSize: "14px" }}>5% (3% rewards to holders, 1% buyback, 1% marketing)</p>
        </div>
  
    </div>
</div>


                        </div>
                    </div>
                    <div className="col-md-5 col-lg-6 order-0 order-md-1 mt-3 mt-md-0" data-aos="fade-left">
                        <img src={tkn} className='w-100' alt="" />
                    </div>
                </div>
                <p className='nor_font fs-5 mt-4 text-center fw-semibold' style={{color:"#FFFFFFCC"}}>Each token represents a stake in our collective future, aligning financial incentives with conservation goals.</p>
            </div>
            <img src={l_roc} className='d-none d-md-block l_roc' style={{width:"600px"}} alt="" />
            <img src={r_roc} className='d-none d-md-block r_roc' style={{bottom:"-10%"}} alt="" />
        </section>
    )
}
